import React from "react";

const TopSideArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 140 122"
      className="top-side-arrow-icon"
    >
      <path
        d="M138.901 115.975c1.4 1.3 1.4 3.6.1 4.9-.7.7-1.6 1.1-2.5 1.1-.9 0-1.7-.3-2.4-1l-64.1-61.7-64.1 60.6c-1.4 1.3-3.6 1.3-4.9-.1-1.3-1.4-1.3-3.6.1-4.9l66.5-62.9c1.4-1.3 3.5-1.3 4.8 0l66.5 64zm-133-47.1 64.1-60.6 64.1 61.7c.7.7 1.6 1 2.4 1 .9 0 1.8-.4 2.5-1.1 1.3-1.4 1.3-3.6-.1-4.9l-66.5-64c-1.3-1.3-3.5-1.3-4.8 0l-66.5 62.8c-1.4 1.3-1.5 3.5-.1 4.9 1.3 1.5 3.5 1.5 4.9.2z"
        fill="#000"
        fillRule="nonzero"
      />
    </svg>
  );
};

export default TopSideArrowIcon;
